.container {
    display: flex;
    justify-content: center;
    width: 100%;
    padding: var(--bi-scale-10x) var(--bi-scale-8x);
    background-color: var(--bi-color-background);
    color: var(--bi-color-text);

    .content {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        max-width: 700px;
        gap: var(--bi-scale-3x) var(--bi-scale-6x);
        font: var(--bi-font-body-medium);
    }

    .title {
        font: var(--bi-font-title-regular-large);
    }
}
